import { CircularProgress, styled } from '@mui/material';
import { ReactElement } from 'react';

import { BlendDown } from '../blend-down/blend-down';

const StyledSpinner = styled(CircularProgress)(({ theme }) => ({
    width: '80px !important',
    height: '80px !important',
}));

export interface LoadingSpinnerProps {
    isVisible?: boolean;
}

export const LoadingSpinner = (props: LoadingSpinnerProps): ReactElement | null => {
    return (
        <BlendDown open={!!props.isVisible}>
            <StyledSpinner />
        </BlendDown>
    );
};
